module.exports = __webpack_public_path__ + "img/value-teaser-01.da2853fd.jpg";